// extracted by mini-css-extract-plugin
module.exports = {"numpad":"Numpad_numpad__2oDtD","icon":"Numpad_icon__RVVFd","row":"Numpad_row__1Vr5P","button":"Numpad_button__26Lat","number":"Numpad_number__2w68S"};